import { FieldType, ViewModelBase } from "@shoothill/core";
import { action, observable, runInAction } from "mobx";
import { DashboardModel } from "../../Models/Domain/Dashboard/DashboardModel";
import { StoresInstance } from "../../Stores";
import { FormSectionsEnum } from "Globals/Models/FormSectionsEnum";
import { Amendment } from "Globals/Models/Amendment";
import { AmendmentsModel } from "Globals/Models/Domain/Admin/applicant/AmendmentsModel";
import AmendmentViewModel from "./AmendmentViewModel";
import { allSections } from "Views/Admin/Applicants/Applicant/LogEntry";
import { AmendmentModel } from "Globals/Models/Domain/Admin/applicant/AmendmentModel";
const domainStores = StoresInstance.Domain;

export default class AmendmentsViewModel extends ViewModelBase<AmendmentsModel> {
    @observable public amendmentViewModels: AmendmentViewModel[] = [];
    constructor(amendments: AmendmentsModel) {
        super(amendments);
        this.createViewModels();
    }

    @action
    public save = async () => {
        this.amendmentViewModels.forEach(async (amendmentViewModel) => {
            await amendmentViewModel.save();
        });
    };
    @action
    public cancel = () => {
        this.amendmentViewModels.forEach((amendmentViewModel) => {
            amendmentViewModel.model.reset();
        });
    };

    @action
    private getAmendmentViewModle = (section: FormSectionsEnum): AmendmentViewModel | undefined => {
        return this.amendmentViewModels.find((a) => a.model.formSection === section);
    };

    @action
    private createViewModels(): void {
        if (this.model.amendments) {
            for (const model of this.model.amendments) {
                this.amendmentViewModels.push(new AmendmentViewModel(model));
            }
        }

        allSections.forEach((section) => {
            if (this.getAmendmentViewModle(section.formSection) == undefined) {
                let amendment: Amendment = {
                    id: "",
                    formId: this.model.formId,
                    applicantId: this.model.applicantId,
                    formSection: section.formSection,
                    amendmentNotes: "",
                    createdDate: null,
                    isDeleted: false,
                };
                let model = new AmendmentModel();
                model.fromDto(amendment);
                let viewModel = new AmendmentViewModel(model);
                runInAction(() => {
                    this.amendmentViewModels.push(viewModel);
                });
            }
        });
    }

    public async isFieldValid(fieldName: keyof FieldType<AmendmentsModel>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
